import { SecondaryTileCallouts } from './secondary-tile-callouts.component.js';
export { SecondaryTileCallouts } from './secondary-tile-callouts.component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';

const SecondaryTileBadges = deprecatedComponent({
    displayName: 'SecondaryTileBadges',
    root: SecondaryTileCallouts,
    description: 'Use SecondaryTileCallouts component Instead'
}) /* PLOP_COMPONENT_EXPORT_IN_INDEX */ ;

export { SecondaryTileBadges };
